import React from 'react';
import './components.css';

export default function Footer() {
  return (
    <div>
      <div className='footer'>
        <center>
          <p className='mb-1'>connect with me</p>
          <a href='https://www.facebook.com/akulsr0'>
            <small>facebook</small>
          </a>
          <a href='https://www.instagram.com/akulsr0/'>
            <small>instagram</small>
          </a>
          <a href='https://twitter.com/akulsr0'>
            <small>twitter</small>
          </a>
          <a href='https://www.linkedin.com/in/akulsr0/'>
            <small>linkedin</small>
          </a>
          <a href='https://github.com/akulsr0'>
            <small>github</small>
          </a>
        </center>
        <br />
      </div>
    </div>
  );
}
